

const SignUpByPhoneComponent = () => {
    return (
        <>
            <div className="input-group mb-2">
                <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1"><span className="mdi mdi-cellphone-message"></span></span>
                </div>
                <input type="text" className="form-control" placeholder="เบอร์โทรศัพท์" aria-label="phoneno" aria-describedby="basic-addon1"></input>
                <div className="input-group-append">
                    <button className="btn btn-primary" type="button">รับรหัส OTP</button>
                </div>
            </div>
        </>
    );
}

export default SignUpByPhoneComponent;